// var q = {};
//
//
function _filterElem(arr){
  var res = arr;
  var title =  $('#fonctionCustomSelect button').data('value');
  var expertise =  $('#expertiseCustomSelect button').data('value');
  var sector =  $('#sectorCustomSelect button').data('value');
  var name = $('#filterName').val();


  if(title!=undefined){
    $('.js-reset-lawyers-filters').show();
    res = res.filter(function(elem){
      return elem.title == title
    });
  }

  if(expertise!=undefined){
    $('.js-reset-lawyers-filters').show();
    res = res.filter(function(elem){
      return elem.expertises.indexOf(expertise)>-1
    })
  ;}

  if(sector!=undefined){
    $('.js-reset-lawyers-filters').show();
    res = res.filter(function(elem){
      return elem.sectors.indexOf(sector)>-1
    });
  }
  if(name.length>=3){
    $('.js-reset-lawyers-filters').show();
    res = res.filter(function(elem){
      return (elem.full_name.toLowerCase().indexOf(name.toLowerCase()) != -1)
    });
  }
  return res
}
// function search(elem,i){
//
// }


function displayLawyers(arr){
  // var parseTags = new Array();
  //   parseTags.push("{$");
  //   parseTags.push("$}");

  // sectorCustomSelect
  $('#teamSlider').fadeOut(function(){
    var template = '{$ #lawyers $} \
      <div class="team-element"> \
        <a href="{$ link $}"> \
          <div class="img-block"> \
              <div class="bg-image-team" style="background-image: url({$ picture $})"></div> \
          </div> \
          <div class="name"> \
            <p class="c-black tt-uppercase">{$ first_name $} {$ last_name $}</p> \
          </div> \
        </a> \
      </div> \
    {$ /lawyers $}';

    Mustache.parse(template, ["{$", "$}"]);

    var rendered = Mustache.render(template, {lawyers:_filterElem(arr)});
    $('#teamSlider').html(rendered);
    $('#teamSlider').fadeIn(function(){})
    $(window).trigger('resizeContainer')

  })
}

function resetLawyerFilters(lawyers){
  function resetBtn(btn){
    btn.removeData('value');
    btn.text(btn.data('originalText'));
  };

  resetBtn($('#fonctionCustomSelect button'));
  resetBtn($('#expertiseCustomSelect button'));
  resetBtn($('#sectorCustomSelect button'));
  $('#filterName').val('');
  window.location.hash = '';
  displayLawyers(lawyers);
  $('.js-reset-lawyers-filters').hide();

}
